/* used to embed contents on various pages */
import log from '@/logger';
import cmsContentMixin from '@/mixins/cmsContent';
import store from '@/store';
import { createOptionalStaticPageLoader } from './optional-static-page-model';

const loadStaticPage = createOptionalStaticPageLoader((key) =>
  store.dispatch('browse/getStaticPageFullWithOptions', { key, optionalInsert: true }),
);

export default {
  mixins: [cmsContentMixin],
  props: {
    pageKey: { type: String, default: null },
    enabled: { type: Boolean, default: true },
  },
  data() {
    return { generation: 0, disposed: false, activeKey: null };
  },
  computed: {
    effectiveKey() {
      return this.enabled && typeof this.pageKey === 'string' && this.pageKey.trim()
        ? this.pageKey
        : null;
    },
  },
  watch: {
    effectiveKey: { immediate: true, handler: 'resolveContent' },
  },
  methods: {
    async resolveContent(key) {
      if (this.disposed || key === this.activeKey) return;
      this.activeKey = key;
      const generation = ++this.generation;
      this.content = '';
      this.cmsInstallGeneration += 1;
      try {
        if (this.cmsWidgetApps.length || this.cmsScopedRuntimes.size) this.destroyCmsWidgets();
        if (this.mapWidgetApps?.length) this.destroyMapWidgets();
        if (!key || this.disposed) return;
        const data = await loadStaticPage(key);
        if (!data || this.disposed || generation !== this.generation) return;
        this.installDynamicControls({ data, suppressMarketChartsGlobalLoader: true });
      } catch (error) {
        if (this.disposed || generation !== this.generation) return;
        this.content = '';
        this.cmsInstallGeneration += 1;
        log.error(`Optional CMS insert failed (${key || ''}).`, error);
      }
    },
  },
  beforeUnmount() {
    this.disposed = true;
    this.generation += 1;
  },
};
